<template>
  <MyIndexPage></MyIndexPage>
</template>

<script>

import MyIndexPage from './views/MyIndexPage';


export default {
  name: 'App',
  metaInfo: {
    title: '侨鑫（广西）信息科技有限公司',
    meta: [
      { name: 'description', content: '侨鑫（广西）信息科技有限公司，医汇' },
      { name: 'keywords', content: '侨鑫（广西）信息科技有限公司，医汇，医讯' }
    ]
  },
  components: {
    MyIndexPage
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  color: #333333;
}
</style>
